import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Typography,
  Paper
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import HomeIcon from '@mui/icons-material/Home';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md">
      <Paper
        elevation={0}
        sx={{
          p: 5,
          mt: 10,
          mb: 10,
          borderRadius: 2,
          textAlign: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}
      >
        <Typography
          variant="h1"
          color="primary"
          sx={{
            fontSize: { xs: '4rem', md: '6rem' },
            fontWeight: 700,
            mb: 2
          }}
        >
          404
        </Typography>
        
        <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
          {t('Page non trouvée')}
        </Typography>
        
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {t('La page que vous recherchez n\'existe pas ou a été déplacée.')}
        </Typography>
        
        <Button
          component={RouterLink}
          to="/"
          variant="contained"
          color="primary"
          size="large"
          startIcon={<HomeIcon />}
          sx={{
            borderRadius: 2,
            px: 4,
            py: 1.5,
            fontWeight: 600,
            boxShadow: '0 4px 14px rgba(30, 64, 175, 0.4)',
            '&:hover': {
              boxShadow: '0 6px 20px rgba(30, 64, 175, 0.6)',
              transform: 'translateY(-2px)'
            }
          }}
        >
          {t('Retour à l\'accueil')}
        </Button>
      </Paper>
    </Container>
  );
};

export default NotFound; 